'use client'

import {createContext} from 'react'
import {ProductDataType} from '@local/types/components'

interface RetreatDetailsContextType extends ProductDataType {
	isOpen: boolean
	setIsOpen: (arg: boolean) => void
}

const RetreatDetailsContext = createContext<RetreatDetailsContextType>({
	product: {
		_id: '',
		_type: '',
		accomodation: '',
		endDate: '',
		includedItems: [],
		location: '',
		maxPeopleCount: 0,
		maxDropdownCount: 0,
		notIncludedItems: [],
		slug: '',
		specialGuests: '',
		startDate: '',
		food: [],
		overviewText: '',
		store: {
			gid: '',
			priceRange: {
				maxVariantPrice: 0,
				minVariantPrice: 0,
			},
			variants: {
				nodes: [],
			},
			images: [],
		},
		title: '',
		allSlugs: {},
	},
	variant: {},
	variants: [],
	isNotFound: false,
	isOpen: false,
	setIsOpen: () => {},
})

export default RetreatDetailsContext
